import MaterialIconsReact from 'material-icons-react';
import styles from './UploadProgress.module.css';
import { useState } from 'react';
import CircularProgress from './CircularProgress';
import Modal from './Modal';

function UploadProgress(props) {
  const [open, setOpen] = useState(true);
  const [showFailedList, setShowFailedList] = useState(false);
  if (!props.rowList || props.rowList.length === 0) {
    return null;
  }

  const onClearAll = () => {
    setShowFailedList(false);
    props.clearAll();
  }

  let totalFailed = Object.values(props.failedList).reduce((acc,element) => acc + element.length, 0);
  return (
    <div className={styles.uploadProgressWrapper}>
      <div className={styles.uploadHeader} onClick={() => setOpen(!open)}>
        <span>Uploading {totalFailed > 0 && <span className={styles.error}>({`${totalFailed} failed`})</span>}</span>
        {open && <MaterialIconsReact icon="expand_more" size={20} color={'#666666'}></MaterialIconsReact>}
        {!open && <MaterialIconsReact icon="expand_less" size={20} color={'#666666'}></MaterialIconsReact>}
      </div>

      {open && props.rowList.map((rowItem, index) => {
        let progressPercentage = Math.ceil((rowItem.uploaded / rowItem.totalUploaded)*100)
        return <div className={styles.progress} key={index}>
          <span>{rowItem.poCode}</span>
          <span>{rowItem.uploaded + ' of ' + rowItem.totalUploaded}</span>
          {props.failedList[rowItem.poCode] && <span className={styles.failedIcon} onClick={() => setShowFailedList(true)}>View <MaterialIconsReact icon="info" size={16} color={'#DB382A'}></MaterialIconsReact></span>}
          <CircularProgress radius={14} stroke={3} progress={progressPercentage} className={styles.loaderInline}></CircularProgress>
        </div>
      })}
      {showFailedList && <Modal title={'Failed Upload List'} onClose={() => setShowFailedList(false)} primaryAction={onClearAll} primaryTitle="Clear All">
        {Object.keys(props.failedList).map((poCode, i) => {
          return (props.failedList[poCode].map((files, j) => {
            return (<div className={styles.progress} key={i+j}>
              <span>{poCode}</span>
              <span className={styles.ml20}>{files.file.name}</span>
            </div>)
          }))
        })}
      </Modal>}
    </div>
  );
}

export default UploadProgress;